import { Project } from '@dc-shared-web/hooks'
import { AxiosInstance } from 'axios'

export type CreateProjectParams = {
  name: string
  teamId?: string
  crunchUUID?: string
  folderId?: string
  folderUuid?: string
  office_uuid?: string
}

export const createProject = async (
  apiClient: AxiosInstance,
  params: CreateProjectParams
): Promise<Project> => {
  const { data } = await apiClient.post(`/api/project-info/`, {
    name: params.name,
    parent_uuid: params.folderUuid ?? null,
    type: params.folderUuid ? 'folder' : null,
    office_uuid: params.office_uuid,
  })

  return data
}

export const createProjectOld = async (
  apiClient: AxiosInstance,
  params: CreateProjectParams
): Promise<Project> => {
  const {
    data: { data },
  } = await apiClient.postForm(`/ajax/project-info`, params)

  return data
}
